import { compose } from "ramda";
import React from "react";
import { FormattedNumber } from "react-intl";
import splitFormattedCurrency from "./utils/splitFormattedCurrency";
const formatCurrency = (currency = "", hideSymbol = false) => {
  const nonUsDollars = (replacerOne, replacerTwo, regexReplace) => (value) => {
    const replacer = !/\$/.test(value) ? replacerOne : replacerTwo;
    const newValue = value.replace(regexReplace, hideSymbol ? "" : replacer);
    return newValue;
  };
  const replacers = {
    USD: (value) => value.replace(/\$?usd?\$?/i, "$"),
    AUD: nonUsDollars("A$", "$1A$2", /(\$)?au?d?(\$)?/i),
    CAD: nonUsDollars("C$", "$1C$2", /(\$)?ca?d?(\$)?/i),
    SEK: (value) => value.replace(/sek/i, hideSymbol ? "" : "kr"),
    CHF: (value) => value.replace(/chf/i, hideSymbol ? "" : "CHF"),
    GBP: (value) => value.replace(/£?gbp?£?/i, "\xA3"),
    JPY: (value) => value.replace(/¥?jpy?¥?/i, "\xA5"),
    NOK: (value) => value.replace(/nok/i, hideSymbol ? "" : "kr"),
    DKK: (value) => value.replace(/dkk/i, hideSymbol ? "" : "kr"),
    noOp: (value) => value
  };
  return replacers[currency] || replacers.noOp;
};
const renderCurrency = (hideDecimalsForIntegers, styleSymbol, currency = "") => (formattedCurrency) => {
  if (!hideDecimalsForIntegers && !styleSymbol) {
    return formattedCurrency;
  }
  const { prefix, units, decimals, suffix } = splitFormattedCurrency(formattedCurrency);
  const hideDecimals = hideDecimalsForIntegers && decimals.substring(1) === "00";
  const currencyStyles = styleSymbol && styleSymbol.currencyCode === currency ? styleSymbol.style : void 0;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, prefix && /* @__PURE__ */ React.createElement("span", {
    className: currencyStyles
  }, prefix), units, !hideDecimals && /* @__PURE__ */ React.createElement("span", null, decimals), suffix && /* @__PURE__ */ React.createElement("span", {
    className: currencyStyles
  }, suffix));
};
const wrapSpan = (testId) => (value) => /* @__PURE__ */ React.createElement("span", {
  "data-test": testId
}, value);
const FormattedCurrency = (props) => {
  const { testId, hideDecimalsForIntegers, styleSymbol, hideSymbol, currency } = props;
  const children = compose(wrapSpan(testId), renderCurrency(hideDecimalsForIntegers, styleSymbol, currency), formatCurrency(currency, hideSymbol));
  return /* @__PURE__ */ React.createElement(FormattedNumber, {
    style: "currency",
    ...props
  }, children);
};
var FormattedCurrency_default = FormattedCurrency;
export {
  FormattedCurrency_default as default
};
